import * as React from 'react';
import classNames from 'classnames';
import {
    root,
    content,
    fullWidth as fullWidthClassName,
    fullWidthInVw as fullWidthInVWClassName,
} from './Section.module.scss';

export type SectionProps = {
    backgroundColor?: string;
    classes?: {
        root?: string;
        content?: string;
        fullWidth?: string;
    };
    fullWidth?: boolean;
    fullWidthInVW?: boolean;
};

function Section(
    {
        backgroundColor,
        classes,
        children,
        fullWidth = false,
        fullWidthInVW = false,
    }: React.PropsWithChildren<SectionProps>,
    ref?: React.ForwardedRef<HTMLDivElement>,
) {
    return (
        <section
            className={classNames(root, classes?.root, {
                [classNames(fullWidthClassName, classes?.fullWidth)]: fullWidth,
                [fullWidthInVWClassName]: fullWidthInVW,
            })}
            style={{ backgroundColor }}
            ref={ref}
        >
            <div className={classNames(content, classes?.content)}>
                {children}
            </div>
        </section>
    );
}

export default React.forwardRef<
    HTMLDivElement,
    React.PropsWithChildren<SectionProps>
>(Section);
